// extracted by mini-css-extract-plugin
module.exports = {"footerAttention":"footer-attention-module--footer-attention--1EZ74","footerAttentionInner":"footer-attention-module--footer-attention-inner--orb5-"};